import { ApplicationState, ErrorState } from "@idw-types/state";
import { createSelector } from "reselect";

export const getErrorState = (state: ApplicationState) => {
    return state.error;
};

export const getErrorStateSelector = createSelector(getErrorState, (errorState: ErrorState) => {
    return errorState;
});